export type ColourPalette = {
  lightest: string;
  light: string;
  base: string;
  dark: string;
  darkest: string;
};

export const colors = {
  brand: {
    blue: {
      lightest: '#E4F0F9',
      light: '#93C6E8',
      base: '#4CA1D9',
      dark: '#3878A2',
      darkest: '#1A384B',
    },
    peach: {
      lightest: '#FDECE9',
      light: '#F8B2A9',
      base: '#F48070',
      dark: '#B65F53',
      darkest: '#562D27',
    },
  },
  neutral: {
    ink: {
      lightest: '#959FA8',
      light: '#637381',
      base: '#37424D',
      dark: '#1B2126',
    },
    grey: {
      lightest: '#FAFAFB',
      light: '#F2F3F5',
      base: '#DFE3E8',
      dark: '#CDD1D5',
    },
    greyBlue: {
      lightest: '#AAC5D8',
      light: '#558BB1',
      base: '#406885',
      dark: '#1E313E',
    },
  },
  secondary: {
    red: {
      lightest: '#FDEEEE',
      light: '#F7BCBC',
      base: '#EB5757',
      dark: '#A53D3D',
      darkest: '#5E2323',
    },
    yellow: {
      lightest: '#FFF6D9',
      light: '#FFE999',
      base: '#FFC900',
      dark: '#BF9600',
      darkest: '#594600',
    },
    green: {
      lightest: '#E9F7EF',
      light: '#BEE7CF',
      base: '#27AE60',
      dark: '#1B7A43',
      darkest: '#104626',
    },
    lime: {
      lightest: '#F6FAEB',
      light: '#DBEBAE',
      base: '#A5CD35',
      dark: '#7B9927',
      darkest: '#394712',
    },
    teal: {
      lightest: '#E5F8F5',
      light: '#99E5D7',
      base: '#00BD9A',
      dark: '#00715C',
      darkest: '#00392E',
    },
    aqua: {
      lightest: '#EEFAFE',
      light: '#BBEBFA',
      base: '#56CCF2',
      dark: '#3C8FA9',
      darkest: '#225261',
    },
    purple: {
      lightest: '#F6EFFC',
      light: '#D9C0F1',
      base: '#A162DD',
      dark: '#694090',
      darkest: '#38224D',
    },
    blue: {
      lightest: '#D9EBF8',
      light: '#80BCE8',
      base: '#0079D1',
      dark: '#005A9C',
      darkest: '#003053',
    },
    pink: {
      lightest: '#FFF1FC',
      light: '#FFC7F3',
      base: '#FFA3EB',
      dark: '#BF7AB0',
      darkest: '#593852',
    },
    orange: {
      lightest: '#FEF5ED',
      light: '#FAD6B7',
      base: '#F2994A',
      dark: '#9D6330',
      darkest: '#613D1E',
    },
  },
  system: {
    scrollbar: {
      thumb: 'rgba(99, 115, 129, .5)',
      background: 'transparent',
    },
  },
};
